var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.5V11.1667C0.5 10.4594 0.780951 9.78115 1.28105 9.28105C1.78115 8.78095 2.45942 8.5 3.16667 8.5H5.83333M6.5 11.1667L7.83333 12.5L10.5 9.83333M1.83333 3.16667C1.83333 3.87391 2.11428 4.55219 2.61438 5.05229C3.11448 5.55238 3.79276 5.83333 4.5 5.83333C5.20724 5.83333 5.88552 5.55238 6.38562 5.05229C6.88572 4.55219 7.16667 3.87391 7.16667 3.16667C7.16667 2.45942 6.88572 1.78115 6.38562 1.28105C5.88552 0.780951 5.20724 0.5 4.5 0.5C3.79276 0.5 3.11448 0.780951 2.61438 1.28105C2.11428 1.78115 1.83333 2.45942 1.83333 3.16667Z",
    stroke: "var(--stroke-0, #1570EF)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/UserCheck.346dd9aa1c2a257fc4b98525686f54ff.svg";
export { ForwardRef as ReactComponent };